import lodash, { get, isEmpty } from 'lodash'
import React from 'react'

import {
  Col,
  FormRow,
  Row,
} from '../../../../../1stlog-ui/src/components/Bootstrap'
import Card from '../../../../../1stlog-ui/src/components/Card'
import Field, {
  required,
  useField,
} from '../../../../../1stlog-ui/src/components/Field'
import Input from '../../../../../1stlog-ui/src/components/Input'
import Select from '../../../../../1stlog-ui/src/components/Select'
import useReturnApp from '../../useReturnApp'

const defaultReturnReasons = {
  seeDeliveryNote: i18n.t('see_delivery_note', 'Siehe Lieferschein'),
  mistakenlyOrdered: i18n.t('mistakenly_ordered', 'Falsch bestellt'),
  mistakenlyReceived: i18n.t('mistakenly_received', 'Falsch erhalten'),
  warranty: i18n.t('warranty', 'Garantie'),
  other: i18n.t('other_reason', 'Anderer Grund'),
}

const Reason = (): React.ReactElement => {
  const { receiver } = useReturnApp()

  const { showReason, isReasonRequired, returnReasons } = receiver

  const reason = useField('reason')

  if (!showReason) {
    return <></>
  }

  return (
    <>
      <Card noHeader>
        <h3>Retoure</h3>
        <FormRow>
          <Col>
            <Field
              key={`reason_key_${isReasonRequired}`}
              name="reason"
              label={i18n.t('reason_of_return', 'Grund der Retoure')}
              required={isReasonRequired}
              validate={isReasonRequired ? required : undefined}
            >
              <Select
                options={
                  isEmpty(returnReasons)
                    ? defaultReturnReasons
                    : returnReasons.map((r) => r.value)
                }
                direct
                placeholder={i18n.t(
                  'please_select_reason',
                  'Wählen Sie einen Grund aus...',
                )}
              />
            </Field>
          </Col>
        </FormRow>
        {reason === 'other' && (
          <FormRow>
            <Col>
              <Field
                key={`reasonDescription_key_${isReasonRequired}`}
                name="reasonDescription"
                label={i18n.t(
                  'input_reason_description',
                  'Bitte Grund angeben',
                )}
                required={isReasonRequired}
                validate={isReasonRequired ? required : undefined}
              >
                <Input />
              </Field>
            </Col>
          </FormRow>
        )}
      </Card>
    </>
  )
}

export default Reason
